import { createContext, useContext, useEffect, useMemo } from "react";
import { useTheme } from "../hooks/useTheme";
import { applyTheme } from "../lib/theme";

const ThemeContext = createContext(null);

// Monta fora do <App />, acima das rotas: Login e NotFound vivem fora do
// AppShell e precisam do tema tanto quanto as telas de dentro.
export function ThemeProvider({ children }) {
  const { preference, resolved, setPreference } = useTheme();

  useEffect(() => {
    applyTheme(resolved);
  }, [resolved]);

  const value = useMemo(
    () => ({ preference, resolved, setPreference }),
    [preference, resolved, setPreference]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useThemeContext() {
  const context = useContext(ThemeContext);
  if (!context) throw new Error("useThemeContext exige um <ThemeProvider> acima na árvore.");
  return context;
}
